var _circle, _path, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrailerLowboy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.3022,
    cy: 21.6447,
    r: 1.33119,
    fill: "#575656"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 19.3101V18.7892L8.56913 17.7185C8.94534 17.6702 9.92926 17.7821 10.8553 18.6156C11.7814 19.449 12.9389 20.5063 13.4019 20.9307H27.7846L29.3473 19.7442C29.6367 19.532 30.3659 19.1075 30.9678 19.1075C31.5698 19.1075 35.9068 19.3005 38 19.3969V19.8889L31.4019 19.7442L30.7942 20.0336L30.7464 20.0858C30.6052 20.0456 30.456 20.0241 30.3019 20.0241C29.4068 20.0241 28.6813 20.7496 28.6813 21.6447C28.6813 21.8496 28.7193 22.0457 28.7888 22.2262L28.6238 22.4066H11.5788L9.66881 20.1783C9.44695 19.8214 8.81801 19.0844 8.07717 18.9918C7.29003 19.0381 3.69775 19.2233 2 19.3101Z",
    fill: "#575656"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.3699,
    cy: 21.6447,
    r: 1.33119,
    fill: "#575656"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.4375,
    cy: 21.6447,
    r: 1.33119,
    fill: "#575656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailerLowboy);
export default __webpack_public_path__ + "static/media/TRAILER_LOWBOY.a3b7c53cdc81d0d4e8c4d13db67885f7.svg";
export { ForwardRef as ReactComponent };